import React from 'react';
import Component from '@vfuk/core-tooltip';
const Tooltip = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Tooltip;
